import moment from "moment";
import config from "@/js/const";
const DateUtils = {
  install: function(Vue) {
    Vue.prototype.$dateUtils = {
      splitDatetime(datetime) {
        if (datetime) {
          const formattedDatetime = moment(
            datetime,
            config.DATETIME_FORMAT_YYYYMMDDHHMMSS
          );
          if (formattedDatetime.isValid()) {
            return {
              date: formattedDatetime.format(
                config.DATE_FORMAT_YYYYMMDD_WITH_HYPHEN
              ),
              hour: formattedDatetime.format(config.TIME_FORMAT_HH),
              minute: formattedDatetime.format(config.TIME_FORMAT_MM)
            };
          }
        }
        return null;
      },
      toHyphenFromSlash(date) {
        if (date) {
          return moment(date).format(config.DATE_FORMAT_YYYYMMDD_WITH_SLASH);
        }
        return null;
      },
      getHours() {
        const hours = [];
        for (let i = 0; i < 24; i++) {
          const hour = `00${i}`.slice(-2);
          hours.push({
            text: hour,
            value: hour
          });
        }
        return hours;
      },
      getMinutes() {
        const minutes = [];
        for (let i = 0; i < 60; i++) {
          const minute = `00${i}`.slice(-2);
          minutes.push({
            text: minute,
            value: minute
          });
        }
        return minutes;
      },
      now(format) {
        return moment().format(format);
      },
      formattedNow() {
        return this.now(config.DATETIME_FORMAT_YYYYMMDDHHMM00);
      },
      formatDatetime(
        datetime,
        format = config.DATETIME_FORMAT_YYYYMMDDHHMM_WITH_SLASH_COLON
      ) {
        const formattedDatetime = moment(
          datetime,
          config.DATETIME_FORMAT_YYYYMMDDHHMMSS
        );
        if (formattedDatetime.isValid()) {
          return formattedDatetime.format(format);
        }
        return "";
      }
    };
  }
};
export default DateUtils;
